import type { ID } from "./common";

export const ADMIN_ROLES = ["owner", "manager", "support"] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export const ADMIN_ROLE_LABELS: Record<AdminRole, string> = {
  owner: "Owner",
  manager: "Manager",
  support: "Support",
};

export interface AdminUser {
  id: ID;
  name: string;
  email: string;
  role: AdminRole;
}

/** Customer identity held by the web app session. */
export interface SessionCustomer {
  id: ID;
  name: string;
  preferredName: string | null;
  phone: string;
  email: string | null;
}
